import { html } from 'lit';
import { textToUnsafeHTML } from '@common/lit/textToUnsafeHTML.js';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

interface TefOneModal extends HTMLElement {
  show() : Promise<unknown>;
}

// Open modal
export const handleClick = async (e : PointerEvent | null) => {
  if (!e?.target) return;
  await ((e.target as HTMLElement).nextElementSibling as TefOneModal).show();
};

//
// renders a <a> with a connected modal
//
export const tefPurposeDescriptionModal = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <span>
      <a href="#modal-purpose-${purpose.purposeId}" @click=${handleClick} style="white-space: nowrap">Weitere Informationen</a>
      <one-modal id="modal-purpose-${purpose.purposeId}" label="${purpose.title}" closable>
        <one-text as="p">
          ${textToUnsafeHTML(purpose.description)}
        </one-text>
      </one-modal>
    </span>
  `;
};
